import UserFavoriteApi from '@/api/UserFavoriteApi';

class UserFavoriteService {
	async listAsync (...args: Parameters<typeof UserFavoriteApi.list>) {
		const res = await UserFavoriteApi.list(...args);
		return res.data ?? [];
	}

	async addAsync (...args: Parameters<typeof UserFavoriteApi.add>) {
		const { data } = await UserFavoriteApi.add(...args);
		return data;
	}

	async deleteAsync (...args: Parameters<typeof UserFavoriteApi.delete>) {
		const { data } = await UserFavoriteApi.delete(...args);
		return data;
	}
}

export default function useUserFavoriteService () {
	return new UserFavoriteService();
}
